<template>
    <div class="tabs-group">
        <div class="tabs">
            <button
                v-for="tab in tabs" :key="tab"
                class="tab" :class="{ 'is-active': selectedTab == tab }"
                @click="selectedTab = tab"
            >{{ tab }}</button>
        </div>
        <slot />
    </div>
</template>

<script>
    export default {
        name: "Tabs"
    }
</script>

<script setup>
    import { ref, provide, useSlots } from 'vue';

    const tabs = ref();
    tabs.value = useSlots()?.default?.().map((tab) => tab?.props?.title);
    const selectedTab = ref(tabs.value[0]);
    provide("selectedTab", selectedTab);
</script>
